import { render } from "./ShareFile.vue?vue&type=template&id=2b9a104f"
import script from "./ShareFile.vue?vue&type=script&lang=js"
export * from "./ShareFile.vue?vue&type=script&lang=js"
script.render = render

export default script